import React from "react";
import { Link } from "react-router-dom";
import { useApiData } from "../hooks/useApiData";
import "./PageContent.css";
import "./GovtApprovalPage.css";

export default function GovtApprovalPage() {
  // GET /api/govt-approval-courses
  // Shape:
  // [
  //   {
  //     courseId,
  //     courseName,
  //     attachments: [
  //       {
  //         fileName,
  //         year,
  //         link
  //       }
  //     ]
  //   }
  // ]

  const { data: courses, loading } = useApiData("govt-approval-courses");
  const { data: leaders } = useApiData("leadership");

  const principal =
    leaders &&
    leaders.find(function (l) {
      return String(l.role || "")
        .toLowerCase()
        .match(/principal|dean/);
    });

  const medicalSuperintendent =
    leaders &&
    leaders.find(function (l) {
      return String(l.role || "")
        .toLowerCase()
        .includes("medical superintendent");
    });

  const slugify = (str) =>
    String(str || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  const renderOfficialMessage = (leader, title) => {
    if (!leader) {
      return null;
    }

    return (
      <div className="official-message-block">
        <div className="official-message-title">{title}</div>

        <div className="official-message-body">
          <div className="official-message-top">
            <div className="official-photo-wrapper">
              <img
                src={leader.img}
                alt={leader.name}
                className="official-photo"
                onError={function (e) {
                  e.target.src =
                    "https://ui-avatars.com/api/?name=" +
                    encodeURIComponent(leader.name || "Official") +
                    "&background=0b5d7a&color=fff&size=150";
                }}
              />
            </div>

            <div className="official-message-text">
              <p>{leader.message}</p>
            </div>
          </div>

          <div className="official-name">{leader.name}</div>

          <div className="official-role">{leader.role}</div>

          <div className="official-more-wrapper">
            <Link
              to={"/leadership-message/" + slugify(leader.role)}
              className="official-more"
            >
              More...
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const list = Array.isArray(courses) ? courses : [];

  return (
    <main className="content-page-wrapper">
      {/* =====================================================
          BREADCRUMB
          ===================================================== */}
      <div className="content-breadcrumb-wrapper">
        <div className="content-container">
          <div className="content-breadcrumb">
            <Link to="/">
              <i className="fa fa-home"></i>
              Home
            </Link>

            <span className="breadcrumb-arrow">
              <i className="fa fa-angle-right"></i>
            </span>

            <span className="breadcrumb-current">
              Govt. Approval
            </span>
          </div>
        </div>
      </div>

      {/* =====================================================
          MAIN CONTENT
          ===================================================== */}
      <div className="content-container">
        <div className="content-layout">

          {/* =================================================
              LEFT SIDEBAR
              ================================================= */}
          <aside className="content-sidebar">
            <div className="official-info-card">

              <div className="official-info-header">
                <div className="official-info-icon">
                  <i className="fa fa-envelope-o"></i>
                </div>

                <span>MESSAGE FROM</span>
              </div>

              <div className="official-info-body">

                {renderOfficialMessage(
                  principal,
                  "DEAN AND PRINCIPAL"
                )}

                {renderOfficialMessage(
                  medicalSuperintendent,
                  "MEDICAL SUPERINTENDENT"
                )}

              </div>
            </div>
          </aside>

          {/* =================================================
              RIGHT MAIN CONTENT
              ================================================= */}
          <section className="content-main-card">

            <h1 className="notice-page-title">
              GOVT. APPROVAL DETAIL
            </h1>

            {/* =================================================
                LOADING
                ================================================= */}
            {loading ? (
              <div className="content-loading">
                <div className="content-spinner"></div>

                <p>
                  Loading govt. approval details...
                </p>
              </div>

            ) : list.length === 0 ? (

              /* =================================================
                 EMPTY
                 ================================================= */
              <div className="govt-approval-empty">
                -- No Record Available --
              </div>

            ) : (

              /* =================================================
                 TABLE
                 ================================================= */
              <div className="govt-approval-table-wrapper">

                <table className="govt-approval-table">

                  <thead>
                    <tr>
                      <th>S.No.</th>

                      <th>
                        Course Name
                      </th>

                      <th>
                        Approval Documents - Year-wise.
                      </th>
                    </tr>
                  </thead>

                  <tbody>

                    {list.map(function (course, i) {

                      return (
                        <tr key={course.courseId}>

                          {/* S.NO */}
                          <td>
                            {i + 1}
                          </td>

                          {/* COURSE NAME */}
                          <td>
                            {course.courseName}
                          </td>

                          {/* DOCUMENTS */}
                          <td className="govt-approval-documents-cell">

                            {!course.attachments ||
                            course.attachments.length === 0 ? (

                              "-"

                            ) : (

                              <div className="govt-approval-doc-buttons">

                                {course.attachments.map(
                                  function (att, idx) {

                                    /*
                                     * Find how many times
                                     * this year appeared before
                                     * the current attachment.
                                     */
                                    const sameYearIndex =
                                      course.attachments
                                        .slice(0, idx)
                                        .filter(function (item) {
                                          return (
                                            String(item.year) ===
                                            String(att.year)
                                          );
                                        }).length + 1;

                                    /*
                                     * Count total attachments
                                     * having the same year.
                                     */
                                    const sameYearCount =
                                      course.attachments.filter(
                                        function (item) {
                                          return (
                                            String(item.year) ===
                                            String(att.year)
                                          );
                                        }
                                      ).length;

                                    /*
                                     * If year occurs only once:
                                     *
                                     * 2025
                                     *
                                     * If year occurs multiple times:
                                     *
                                     * 2025(1)
                                     * 2025(2)
                                     * 2025(3)
                                     */
                                    const displayYear =
                                      sameYearCount > 1
                                        ? String(att.year) +
                                          "(" +
                                          sameYearIndex +
                                          ")"
                                        : String(att.year);

                                    return (
                                      <a
                                        key={idx}
                                        href={att.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={
                                          "govt-approval-doc-link govt-approval-doc-color-" +
                                          (idx % 8)
                                        }
                                        title={
                                          att.fileName
                                            ? "Open " +
                                              att.fileName
                                            : "Open document"
                                        }
                                      >
                                        {displayYear}
                                      </a>
                                    );
                                  }
                                )}

                              </div>
                            )}

                          </td>

                        </tr>
                      );
                    })}

                  </tbody>

                </table>

              </div>
            )}

          </section>

        </div>
      </div>
    </main>
  );
}
